export default "__VITE_ASSET__15La2ZzK__"